import { Radii, Size, Spacing } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { PhoneComponentSizes } from './Constants'

const {
  CallControl: {
    Bar: { padding: BarPadding },
  },
} = PhoneComponentSizes

const callControlParts = [
  'bar',
  'drawer',
  'drawerHeader',
  'drawerHeaderText',
  'drawerHeaderIconButton',
  'drawerHeaderIcon',
  'icon',
  'tooltip',
] as const

const helpers = createMultiStyleConfigHelpers(callControlParts)

export const CallControlStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bar: {
      bg: 'bg.panel',
      width: 'fit-content',
      gap: Spacing._4,
      borderRadius: Radii.lg,
      border: '2px solid',
      borderColor: 'bg.muted',
    },
    drawer: {
      bg: 'bg.panel',
      height: 'fit-content',
      marginBottom: '-1px',
      paddingX: Spacing._5,
      paddingTop: Spacing._3,
      borderTopRadius: '12px',
      border: '2px solid',
      borderColor: 'border.muted',
    },
    drawerHeader: {
      height: '40px',
      width: 'full',
      paddingY: '8px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: Radii.lg,
    },
    drawerHeaderText: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    drawerHeaderIconButton: {
      marginRight: '-10px',
    },
    drawerHeaderIcon: {
      boxSize: '30px',
      color: 'fg.default',
      background: 'transparent',
    },
    icon: {
      color: 'fg.default',
      boxSize: '40px',
    },
    tooltip: {},
  },
  sizes: {
    [Size.sm]: {
      bar: {
        padding: BarPadding.sm.px,
      },
      drawer: {
        width: '380px',
      },
      icon: {},
    },
    [Size.md]: {
      bar: {
        padding: BarPadding.md.px,
      },
      drawer: {
        width: '380px',
      },
      icon: {},
    },
    [Size.lg]: {
      bar: {
        padding: BarPadding.lg.px,
      },
      drawer: {
        width: '460px',
      },
      icon: {},
    },
    [Size.xl]: {
      bar: {
        padding: BarPadding.xl.px,
      },
      drawer: {
        width: '624px',
      },
    },
  },
})

export const useCallControlStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CallControlStyle, props) as MultiStyleType<
    typeof callControlParts
  >
}
